// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8c4a5ea0","14":"a57b7da3","19":"95866e7b","141":"58d4a694","247":"83d6d401","253":"2f919fb4","454":"65ebb717","496":"2272915f","503":"1e3d78e9","534":"f9a863bf","588":"c5d53fff","737":"d08d5db8","857":"4508f868","984":"0d585e6a"}[chunkId] + ".chunk.js";
};